import { useEffect, useState } from "react";
import { useService } from ".";
import { useAuth } from "@with-nx/auth";

export const useCustomizableCues = (id?: number | string) => {
  const [cues, _cues] = useState<
    {
      id: number;
      name: string;
      cue_description: string;
      cue_line: string;
      cue_page_number: string;
    }[]
  >([]);

  const auth = useAuth();

  useEffect(() => {
    if (!id) {
      _cues([]);
      return;
    }

    const service = useService("accounts");

    let current = true;

    (async () => {
      const data = (await service(
        "GET",
        `/api/v2/scenic_projections_rentals/${id}/customizable_cues`,
        undefined,
        {
          Authorization: `Bearer: ${auth.authState.session?.token}`,
        }
      )) as unknown as {
        cues: {
          id: number;
          name: string;
          cue_description: string;
          cue_line: string;
          cue_page_number: string;
        }[];
      };

      if (current && data?.cues) {
        _cues(
          data?.cues as unknown as {
            id: number;
            name: string;
            cue_description: string;
            cue_line: string;
            cue_page_number: string;
          }[]
        );
      }
    })();

    return () => {
      current = false;
    };
  }, [id]);

  return cues;
};
